import React, { useEffect, useMemo, useState } from "react";
import NodeNameValidation from "../../atoms/node-name-validation";
import { Col, Form, FormGroup, Input, Label, Row, Card } from "reactstrap";
import { QUANTIFIERS } from "../../../constants";
import ConditionSelector from "../condition-selector";
import { cloneDeep } from "lodash";
import HelpTooltip from "../../atoms/help-tooltip";
import { t } from "../../../utils/utils";
import T from "../../atoms/translate";
export default function NodeDeleteProperty({ node, nodeChange, dependencies }) {
  const models = useMemo(() => dependencies.getModels().models, [dependencies]);
  const [inputData, setInputData] = useState({});
  const [selectors, setSelectors] = useState([]);
  const [logic, setLogic] = useState("");
  const [model, setModel] = useState("");
  const [quantifier, setQuantifier] = useState("");
  const fields = useMemo(() => {
    const tmp = models.find(o => o.name === model);
    return tmp ? tmp.attributes : [];
  }, [models, model]);
  const changeSelect = ({ target }, setter) => {
    const values = [].filter
      .call(target.options, o => o.selected)
      .map(o => o.value);
    setter(values[0]);
  };
  useEffect(() => {
    const { args } = node.properties;
    if (args) {
      if (args.inputData) {
        setInputData(args.inputData);
      }
      if (args.deleteAction && args.deleteAction.model) {
        setModel(args.deleteAction.model);
        setQuantifier(args.deleteAction.quantifier);
        if (args.deleteAction.selectors) {
          const Logic = Object.keys(args.deleteAction.selectors)[0];
          setLogic(Logic.replace("$", ""));
          setSelectors(
            args.deleteAction.selectors[Logic].map(o => {
              const operator = Object.keys(o)[0];
              return {
                operator: operator.replace("$", ""),
                left: o[operator][0],
                right: o[operator][1]
              };
            })
          );
        }
      }
    }
  }, [node]);
  const onSubmit = name => {
    const tmp = cloneDeep(node);
    tmp.properties.name = name;
    tmp.properties.args.inputData = inputData;
    if (quantifier && model && selectors) {
      tmp.properties.args.deleteAction = {
        model: model,
        selectors: {
          [`$${logic}`]: selectors.map(o => ({
            [`$${o.operator}`]: [o.left, o.right]
          }))
        },
        quantifier: quantifier
      };
    }
    nodeChange(tmp);
  };
  //TODO: es posible que se a mas eficiente hacer un wrapper de los nodos de base de datos
  return (
    <>
      <NodeNameValidation
        label={t("modalPropiedadesLabelNodoValidacionNombre")}
        feedback={t("modalPropiedadesFeedbackValidacionNombre")}
        nodesNames={dependencies.nodeNames}
        oldName={node.properties.name}
        onSubmit={onSubmit}
      />
      <Card body className="border-0 box-shadow mb-4">
        <Row>
          <Col xs="12">
            <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
              <T i18nKey="modelPropiedadesConfiguracionInicial" />
            </h1>
          </Col>
          <Col xs="12">
            <Form>
              <Row form>
                <Col md={5}>
                  <FormGroup>
                    <Label>
                      <T i18nKey="modelo" />{" "}
                      <HelpTooltip
                        msg={t("modalPropiedadesBorrarTituloTooltip")}
                      />
                    </Label>

                    <Input
                      type="select"
                      onChange={e => changeSelect(e, setModel)}
                      value={model}
                      required={true}
                    >
                      <option value="" />
                      {models.map((o, key) => (
                        <option key={key}>{o.name}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <Label>
                      <T i18nKey="modalPropiedadesCuantificador" />{" "}
                      <HelpTooltip
                        msg={
                          <p className="mb-0">
                            <T i18nKey="modalPropiedadesCuantificadorOne" />
                            <br />
                            <T i18nKey="modalPropiedadesCuantificadorMany" />
                          </p>
                        }
                      />
                    </Label>
                    <Input
                      type="select"
                      onChange={e => changeSelect(e, setQuantifier)}
                      value={quantifier}
                      required={true}
                    >
                      {<option value="" />}
                      {QUANTIFIERS.map((o, key) => (
                        <option key={key}>{o}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>

      <Row>
        <Col>
          <ConditionSelector
            context={dependencies.context}
            fields={fields}
            logic={logic}
            setLogic={setLogic}
            setSelectors={setSelectors}
            selectors={selectors}
            inputData={inputData}
            setInputData={setInputData}
            operators={[
              "eq",
              ">=",
              "<=",
              ">",
              "<",
              "!=",
              "notExists",
              "exists"
            ]}
          />
        </Col>
      </Row>
    </>
  );
}
